import * as React from 'react';

import Styles from './AppContainer.module.scss';
import { Outlet } from 'react-router-dom';

export const AppContainer: React.FC = () => {
  return (
    <div className={Styles.container}>
      <Outlet />
    </div>
  );
};
